import React from 'react';
import { KeyLicenseTypeNames, KeyLicenseTypes } from '../common/keyLicenseTypes';
import EditingDataHistoryDialog from './editingDataHistoryDialog';
import OfflineLicenseHistoryTable from './offlineLicenseHistoryTable';
import PermanentLicenseHistoryTable from './permanentLicenseHistoryTable';
import TemporaryLicenseHistoryTable from './temporaryLicenseHistoryTable';

export default class KeyLicenseHistoryDialog extends EditingDataHistoryDialog {
  get Title() {
    return `${KeyLicenseTypeNames[this.LicenseType]} license history`;
  }

  get LicenseType() {
    throw new Error("License type is not defined!");
  }

  get dataId() {
    return this.props.id;
  }

  renderBeforeContent() {
    return <p>License key: <strong>{this.props.licenseKey}</strong></p>;
  }

  renderTable(tableProps) {
    switch(this.LicenseType) {
      case KeyLicenseTypes.OnlinePermanent:
        return <PermanentLicenseHistoryTable {...tableProps}/>;
      case KeyLicenseTypes.OnlineTemporary:
        return <TemporaryLicenseHistoryTable {...tableProps}/>;
      case KeyLicenseTypes.Offline:
        return <OfflineLicenseHistoryTable {...tableProps}/>;
      default:
        return <p>Unknown license type</p>
    }
  }

  renderContent() {
    if (this.props.objectState.error)
      return this.renderError();
    return this.renderTable({ history: this.props.objectState.data });
  }

  renderError() {
    return (
      <p className="text-danger">Error: {this.props.objectState.error.toString()}</p>
    );
  }

  isLodaing() {
    return this.props.objectState.isFetching;
  }

  getLoaderMessage() {
    if (this.props.objectState.isFetching) {
      return `${KeyLicenseTypeNames[this.LicenseType]} license history loading...`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/keyLicenseHistoryDialog.js